<div class="app-wrap">
  <app-topbar class="app-header" />

  <app-sidenav class="app-sidebar d-flex flex-column" />

  <main class="app-body">
    <div class="app-content">
      <div class="content-wrapper">
        <router-outlet />
      </div>
    </div>

    <app-footer />
  </main>
</div>
